__turbopack_context__.v({
  "button_container": "features-cta-module-scss-module__Bt09lG__button_container",
  "container_section": "features-cta-module-scss-module__Bt09lG__container_section",
  "cta_container": "features-cta-module-scss-module__Bt09lG__cta_container",
  "promo_text": "features-cta-module-scss-module__Bt09lG__promo_text",
});
